import clsx from 'clsx';
import { type FC } from 'react';

export interface ErrorMessageProps {
    className?: string;
    children?: string;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ className, children }) => {
    return (
        <div className={clsx(
            'text-sm text-red-800',
            className
        )}>
            {children}
        </div>
    );
};
